








// DUTY: 과세, DUTYFREE: 면세, SMALL: 영세
import SelectBox from '@/pro/components/common/SelectBox.vue';

type ValueAddedTaxType = 'DUTY' | 'DUTYFREE' | 'SMALL';
import { Vue, Component, PropSync, Prop } from 'vue-property-decorator';
import {OptionData} from '@/pro/helpers/type';
@Component({
  components: { SelectBox },
})
export default class ValueAddedTaxInfo extends Vue {
  @PropSync('valueAddedTaxType')
  private valueAddedTaxTypeSync!: ValueAddedTaxType;

  @Prop({ required: true })
  private readonly disabled: boolean;

  private selectOptions: OptionData<ValueAddedTaxType>[] = [
    { name: 'PRO_PRODUCT_ADD_DUTY', value: 'DUTY' },
    { name: 'PRO_PRODUCT_ADD_DUTYFREE', value: 'DUTYFREE' },
    { name: 'PRO_PRODUCT_ADD_SMALL', value: 'SMALL' },
  ];
}
